import api from '../utils/api';

export const riskService = {
  listDashboard: async (params = {}) => {
    const response = await api.get('/admin/risk/dashboard', { params });
    return response.data.data || response.data;
  },

  getSellerRisk: async (sellerId) => {
    const response = await api.get(`/admin/risk/sellers/${sellerId}`);
    return response.data.data || response.data;
  },

  clearSuspension: async (sellerId, note) => {
    const response = await api.post(`/admin/risk/sellers/${sellerId}/clear-suspension`, { note });
    return response.data;
  },

  hardSuspend: async (sellerId, { reason, confirmedFraud } = {}) => {
    const response = await api.post(`/admin/risk/sellers/${sellerId}/hard-suspend`, {
      reason,
      confirmedFraud,
    });
    return response.data;
  },

  permanentBan: async (sellerId, { reason, confirmedFraud } = {}) => {
    const response = await api.post(`/admin/risk/sellers/${sellerId}/permanent-ban`, {
      reason,
      confirmedFraud,
    });
    return response.data;
  },
};
